import React, { Component } from 'react'
import PropTypes from 'prop-types';
import TextBoxMultiCarFilter from '../UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter';
import { TimePicker } from 'antd';
import DateTimeRange from '../UserControl/DateTimeRange/DateTimeRange';
import moment from 'moment';
import { Alert, AlertCommit } from '../../Modals/AlertBar';
import Chart from 'chart.js';
import { getMainCookie, checkStatus, getFullDate, checkText, setLoader } from '../../../util/util';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
import $ from 'jquery';

import ReactToPrint from "react-to-print";

const Canvas2Image = window.Canvas2Image;
let startHistoryDate = null;
let endHistoryDate = null;
let tagsHistory = null;
let tagsDevice = [];
let myChart = null;

class GraphHeat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isClickLoadReport: '',
            selectHistoryDateRange: {
                startDate: this.getCurrentDate(new Date()),
                endDate: this.getCurrentDate(new Date()),
                startTimeHistory: "00:00",
                endTimeHistory: "23:50"
            },
        };
    }
    btnSearchHistoryClick() {
        const { t } = this.props;
        console.log("btnSearchHistoryClick", this.getCurrentDate(startHistoryDate), this.state.selectHistoryDateRange.startTimeHistory, this.state.selectHistoryDateRange.endTimeHistory, tagsDevice);
        if (tagsDevice.length === 0 || startHistoryDate === null || endHistoryDate === null || this.state.selectHistoryDateRange.startTimeHistory === '' || this.state.selectHistoryDateRange.endTimeHistory === '')
            Alert(t('กรุณาใส่ข้อมูล'), t('รถ วัน เวลา'));
        else {
            let stime = this.state.selectHistoryDateRange.startTimeHistory;
            let etime = this.state.selectHistoryDateRange.endTimeHistory;
            let start = this.getCurrentDate(startHistoryDate);
            let end = this.getCurrentDate(endHistoryDate)
            let dd = this.getCurrentDate(startHistoryDate).split("-")[0];
            let mm = this.getCurrentDate(startHistoryDate).split("-")[1];
            let yyyy = this.getCurrentDate(startHistoryDate).split("-")[2];
            start = dd + "-" + mm + "-" + yyyy;
            dd = this.getCurrentDate(endHistoryDate).split("-")[0];
            mm = this.getCurrentDate(endHistoryDate).split("-")[1];
            yyyy = this.getCurrentDate(endHistoryDate).split("-")[2];
            end = dd + "-" + mm + "-" + yyyy;


            // this.onPageSizeChange(stime,start,etime,end,tagsDevice,this.state.currentPage,this.state.currentPageSize);

            console.log(stime, start, etime, end, tagsDevice)
            this.getChartUserLogin(tagsDevice, stime, start, etime, end);
        }

    }
    getCurrentDate(today) {
        //let today = new Date();
        if (today == null)
            return null;
        let dd = !today.date ? today.getDate() : today.date;
        let mm = today.months == undefined ? today.getMonth() + 1 : today.months + 1; //January is 0! today
        let yyyy = !today.years ? today.getFullYear() : today.years;
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        return (dd + '-' + mm + '-' + yyyy);
    }

    handleStartTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.startTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    handleEndTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.endTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    setRangeDate(sDate, eDate) {
        startHistoryDate = sDate;
        endHistoryDate = eDate;
        if (sDate && eDate && sDate != null && eDate != null) {
            startHistoryDate = sDate.toObject();
            endHistoryDate = eDate.toObject();
        }
        console.log("setRangeDate", startHistoryDate, endHistoryDate);
    }
    setMultiCar(tags) {
        tagsDevice = tags;
        console.log("tag", tagsDevice);
    }
    getChartUserLogin(device_id, stime, start, etime, end) {
        let thisCur = this;
        let start_date = start + " " + stime;
        let end_date = end + " " + etime;
        const { user_id, user_name, token } = this.props;
        setLoader(true);
        fetch("http://203.150.199.244/api/report/getTemperatureGraph", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "devices":
                    device_id
                ,
                "start_date": start_date,
                "end_date": end_date
            })
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            let labels = [];
            let values = [];
            setLoader(false);
            if(data.RESULT_STATUS === "000"){
                console.log("data",data)
                let maxDrup =10;
                let vDrup = 0;
                let lastValue = -1;
                let valueSpeedLimit = [];
                for (let i = 0; i < data.RESULT_DATA.length; i++) {
                    // if(lastValue == data.RESULT_DATA[i].speed && vDrup < maxDrup && data.RESULT_DATA[i].speed==0){

                    //     vDrup++;

                    // }else{
                        lastValue = data.RESULT_DATA[i].value;
                        vDrup = 0;
                        labels.push(data.RESULT_DATA[i].time + "\n" + getFullDate(data.RESULT_DATA[i].date).replace(" 25", " "));
                        values.push(data.RESULT_DATA[i].value);

                        // if(data.RESULT_DATA[i].speed_limit != 0)
                        //     valueSpeedLimit.push(data.RESULT_DATA[i].speed_limit);
                      
                    // }


                }
                $('#ctxHeat').remove();
                $('#printHeat').append('<canvas id="ctxHeat" style={{height:"100vh"}} width={400} height={150} ></canvas>');
                let ctx = document.getElementById("ctxHeat");
                ctx.height = 150;
                ctx.width = 400;
                myChart = new Chart(ctx, {
                    type: 'line',
                    // fill: "start",
                    data: {
                        labels: labels,
                        datasets: 
                        [{
                            label: getFullDate(start).replace(" 25", " ") + " , " + stime + " - " + getFullDate(end).replace(" 25", " ") + " , " + etime,
                            data: values,
                            backgroundColor: [
                                'rgba(255, 120, 0, 0.5)'
                            ],
                            borderColor: [
                                'rgba(255,120,0,1)'
                            ],
                            borderWidth: 1
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        legend: {
                            position: 'top'
                        },
                        title: {
                            display: true,
                            text: "อุณภูมิของรถ " + device_id[0].device_no + " (เซลเซียส)"
                        }
                    }
                });


                $("#dvSpeedPrint").show();
            }
            else{
                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
            }
        },
            (error) => {
                console.log("error", error)
                setLoader(false);
                return error;
            }

        )
    }
    handleClick = () => {
        const { isClickLoadReport } = this.state;
        if (isClickLoadReport === 'show') {
            this.setState({isClickLoadReport: ''});
        } else {
            this.setState({isClickLoadReport: 'show'});
        }
    }

    downloadChart(){
        console.log("downloadChart")
        let ctx = document.getElementById("ctxHeat");
        let imageData = ctx.toDataURL("image/png");
        let doc = new jsPDF('l', 'mm');
        doc.addImage(imageData, 'PNG', 12, 10,270,170);

        doc.save("Heat.pdf");




    }

    render() {
        const { t, onClickBackToReportPortal } = this.props;
        return (
            <div className="gray-panel" style={{minWidth:900,overflowX:"auto",minHeight:"calc(100vh - (50px))"}}>
                <h5 style={{ paddingLeft: '2em',cursor: 'pointer' }} onClick={onClickBackToReportPortal}>
                    <i
                        className="fa fa-arrow-left"
                        aria-hidden="true"
                        style={{ color: 'rgb(115, 134, 213)'}} />
                        <i className="fas fa-file-contract" style={{ color: '#7386D5', marginLeft:10,marginRight:5,cursor:"pointer" }} />{t('รายงานข้อมูล')}
                </h5>

                <hr />

                <h5>
                    <span className="fa-stack fa-lg" style={{ color: 'orange' }}>
                        <i className="fa fa-circle fa-stack-2x" />
                        <i className="fa fa-file-text-o fa-stack-1x" style={{ color: 'white' }} />
                    </span>
                        {t('กราฟอุณหภูมิ')}
                    </h5>

                <hr />

                <div style={{alignContent:"baseLine"}} >
                    <table>
                        <tr>
                            <td colSpan={4}>
                                <div className="col-md-12">
                                    <i className="fas fa-shipping-fast icon-for-calendar" style={{ fontSize: 20, marginLeft: '27px' }} />
                                    <div style={{ display: "inline-block",marginBottom:5 }}>
                                        <TextBoxMultiCarFilter limitSelect={1} onChange={this.setMultiCar.bind(this)} />
                                    </div>

                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label htmlFor="example-text-input" >{t('ระหว่างวันที่')}</label>&nbsp;
                                <TimePicker allowEmpty={false} className="timeHistory" onChange={this.handleStartTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('00:00', 'HH:mm')} format={'HH:mm'} />
                            </td>
                            <td>
                                <div className="date" id="datetimepicker1">
                                    <DateTimeRange
                                        small={true}
                                        isBack
                                        startDateId="MyDatePicker"
                                        endDateId="your_unique_end_date_id"
                                        onSelectDate={this.setRangeDate.bind(this)} />
                                </div>
                            </td>
                            <td>
                                <TimePicker allowEmpty={false} className="timeHistory" onChange={this.handleEndTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('23:50', 'HH:mm')} format={'HH:mm'} />
                            </td>
                            <td>
                                <div className="btn-group">
                                    <button type="button" className="btn btn-primary btn-report" data-ext="html" onClick={(e) => this.btnSearchHistoryClick(e)} >{t('ตกลง')}</button>
                                    <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                                        <span className="caret" />
                                    </button>
                                    <ul className={"dropdown-menu "+this.state.isClickLoadReport} >
                                        <li className="item-text"><a onClick={this.downloadChart.bind(this)}><i className="far fa-file-pdf" style={{ color: '#007bff',fontSize:20,marginLeft:10,marginRight:2 }}/> download</a>
                                        </li>
                                        <ReactToPrint
                                            trigger={() =>
                                                <li className="item-text"><a><i className="fas fa-print" style={{ color: '#007bff',fontSize:20,marginLeft:8 }} /> print</a>
                                                </li>
                                            }
                                            content={() => this.dvPrint}
                                        />

                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

                <div id = "printHeat" className="row" ref={el => (this.dvPrint = el)} style={{backgroundColor:"#fff"}}>
                    {/* <canvas id="ctxHeat" width={400} height={150} ></canvas> */}
                </div>

                <div className="row " id="dvSpeedPrint" style={{display:"none"}}>
                    <div style={{margin:"auto"}}>
                        <button  onClick={this.downloadChart.bind(this)} type="button" style={{width:150}} className="btn btn-light border border-secondary">
                            <i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue'}}/>
                            {t('รายงานแบบ PDF')}
                        </button>
                        <ReactToPrint
                            trigger={() =>
                                <button type="button" className="btn btn-light border border-secondary" style={{width:150}}>
                                    <a><i className="fas fa-print" style={{ color: '#007bff',fontSize:20,marginLeft:8 }} />{t('พิมพ์')}</a>
                                </button>
                            }
                            content={() => this.dvPrint}
                        />
                    </div>
                </div>
            </div>

        );
    }
}

GraphHeat.propTypes = {
    t: PropTypes.func.isRequired
}


export default GraphHeat;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/GraphHeat.js